import { render, staticRenderFns } from "./speciality.vue?vue&type=template&id=348cfb96&"
import script from "./speciality.vue?vue&type=script&lang=js&"
export * from "./speciality.vue?vue&type=script&lang=js&"
import style0 from "./speciality.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports